import { Path } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function ChevronIcon({
  direction = "right",
  ...props
}: IconProps & { direction?: "left" | "right" }) {
  return (
    <LineIcon {...props}>
      <Path d={direction === "left" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7"} />
    </LineIcon>
  );
}
